import { ApplicationRef, Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { concat, interval } from 'rxjs';
import { first } from 'rxjs/operators';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

@Injectable({
  providedIn: 'root'
})
export class UpdateService {

  constructor(
    private readonly update: SwUpdate,
    private readonly app: ApplicationRef,
    private readonly fuseTranslationLoaderService: FuseTranslationLoaderService,
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });

    if (!this.update.isEnabled) {
      return;
    }

    const firstTimeAppStable$ = this.app.isStable.pipe(first((isStable) => isStable === true));
    const everyHalfHours$ = interval(30 * 60 * 1000);

    concat(firstTimeAppStable$, everyHalfHours$).subscribe(async () => {
      await this.update.checkForUpdate();
    });

    this.update.available.subscribe(async () => {
      await this.update.activateUpdate();
    });


    this.update.activated.subscribe(async (event) => {
    });

  }
}
